import { Component, Input, forwardRef, OnInit, Output, EventEmitter, Injectable } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { messages } from '../../../constants/app.messages';
import moment from 'moment';


@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

    readonly DELIMITER = '/';

    fromModel(value: string | null): NgbDateStruct | null {
        if (value) {
            value = value + "";
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[1], 10),
                month: parseInt(date[0], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): string | null {
        return date ? (date.month + "").padStart(2, '0') + this.DELIMITER + (date.day + "").padStart(2, '0') + this.DELIMITER + date.year : null;
    }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

    readonly DELIMITER = '/';

    parse(value: string): NgbDateStruct | null {
        if (value) {
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[1], 10),
                month: parseInt(date[0], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date ? (date.month + "").padStart(2, '0') + this.DELIMITER + (date.day + "").padStart(2, '0') + this.DELIMITER + date.year : '';
    }
}
@Component({
  selector: 'app-mprx-date-picker',
  templateUrl: './mprx-date-picker.component.html',
  styleUrls: ['./mprx-date-picker.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MprxDatePickerComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MprxDatePickerComponent),
      multi: true,
    },
    { provide: NgbDateAdapter, useClass: CustomAdapter }, 
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class MprxDatePickerComponent implements ControlValueAccessor, OnInit {
  @Input() label = 'Select Date';
  @Input() placeholder = '';
  @Input() IsRequired = false;
  @Input() minDate: string | null = null;
  @Input() maxDate: string | null = null;
  @Input() IsFillDtExdedThanOrderDt = false;
  @Input() isDisabled = false;
  @Output() valueChange = new EventEmitter<string>();

  innerControl: FormControl = new FormControl('');
  isInvalid = false;
  touched = false;
  currentDate: string = '';

  private _onChange = (_: any) => {};
  private _onTouched = () => {};
  // twoKeysClick: number | undefined;

  ngOnInit(): void {
    this.innerControl.valueChanges.subscribe((val) => {
      this._onChange(val);
    });
  }

  writeValue(val: any): void {
    const v = !val ? null
    : (val?.year && val?.month && val?.day)
      ? `${String(val.month).padStart(2,'0')}/${String(val.day).padStart(2,'0')}/${val.year}`
      : moment(val, ['MM/DD/YYYY','YYYY-MM-DD', moment.ISO_8601], true).isValid()
        ? moment(val).format('MM/DD/YYYY')
        : null;
  this.innerControl.setValue(v, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.innerControl.disable();
    } else {
      this.innerControl.enable();
    }
  }

  validate(): ValidationErrors | null {
    this.isInvalid = this.IsRequired && !this.innerControl.value && this.touched;
    return this.isInvalid ? { required: true } : null;
    
  }


  onDateChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const date = input.value;
    this.innerControl.setValue(date);
    this._onTouched();
    this.valueChange.emit(date);
  }
  onBlur(): void {
    this.touched = true;
    this._onTouched();
  }
  onDateSelect(date: any) {
     const formattedDate  = `${String(date.month).padStart(2,'0')}/${String(date.day).padStart(2,'0')}/${date.year}`;
  this.innerControl.setValue(formattedDate , { emitEvent: true });
  this._onChange(formattedDate );
  this.valueChange.emit(formattedDate);
  }
      emitOnKeyDown(e?: any) {
        let inputVal = e.target.value;
        inputVal = inputVal.replace(/[^0-9/]/g, "");
        if (((e.which >= 48 && e.which <= 57) || (e.which >= 96 && e.which <= 105)) && inputVal) {
            let slashLength = inputVal.split('').filter((x: string) => x == "/").length;
            if (inputVal && slashLength < 2) {
                const inputValArr = inputVal.replace(/[^0-9]/g, "").match(/.{1,2}/g);
                if (inputValArr.length > 3) {
                    inputVal = inputValArr[0] + "/" + inputValArr[1] + "/" + inputValArr[2] + inputValArr[3];
                } else {
                    inputVal = inputValArr.join("/");
                }
            }
        }
        e.target.value = inputVal;
        
        if(inputVal.length === 10){
           const valid = moment(inputVal, "MM/DD/YYYY", true).isValid();
    if (valid) {
      this.innerControl.setErrors(null);
      this.innerControl.setValue(inputVal, { emitEvent: true });
      this._onChange(inputVal);
      this.valueChange.emit(inputVal);
    } else {
      this.innerControl.setErrors({ inValid: true });   // <-- sets your invalid flag
    }
  }

        // this.twoKeysClick = 0;
    }
}
